import { render, staticRenderFns } from "./LogisticsProductLinesEditor.vue?vue&type=template&id=5cfa63f0&scoped=true"
import script from "./LogisticsProductLinesEditor.vue?vue&type=script&lang=js"
export * from "./LogisticsProductLinesEditor.vue?vue&type=script&lang=js"
import style0 from "./LogisticsProductLinesEditor.vue?vue&type=style&index=0&id=5cfa63f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfa63f0",
  null
  
)

export default component.exports